import {
  TOGGLE_DASHBOARD_WIDGET,
  RESET_DASHBOARD_WIDGETS,
} from '../constants/dashboardWidgetVisibility'

const STORAGE_KEY = 'hiddenDashboardWidgets'

// This is purely a local (per-browser) preference — no backend endpoint
// exists for it, so it's persisted to localStorage only.

export const toggleDashboardWidget = (key) => (dispatch, getState) => {
  dispatch({ type: TOGGLE_DASHBOARD_WIDGET, key })
  const { hiddenKeys } = getState().dashboardWidgetVisibility
  localStorage.setItem(STORAGE_KEY, JSON.stringify(hiddenKeys))
}

export const resetDashboardWidgets = () => (dispatch) => {
  dispatch({ type: RESET_DASHBOARD_WIDGETS })
  localStorage.removeItem(STORAGE_KEY)
}
